import AnimatedScale from './animated_scale'

export default AnimatedScale
